import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LoadingIndicatorService } from '../../e-met/services/loading-indicator.service';

@Directive({
    selector: '[appDisableTableOnRefresh]',
})
export class DisableTableOnRefreshDirective implements OnDestroy {
    sub: Subscription;
    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private loadingIndicator: LoadingIndicatorService
    ) {
        this.sub = this.loadingIndicator.loadingStatus
            .pipe(filter((ev) => ev.reqId === 'refresh'))
            .subscribe((reqData) => {
                reqData.loading ? this.enableClass() : this.disableClass();
            });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    enableClass() {
        this.renderer.addClass(this.el.nativeElement, 'refresh-overlay');
    }

    disableClass() {
        this.renderer.removeClass(this.el.nativeElement, 'refresh-overlay');
    }
}
